/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Listen_LabelInputs */

const en_mcp_cap_listen_label = /** @type {(inputs: Mcp_Cap_Listen_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen`)
};

const es_mcp_cap_listen_label = /** @type {(inputs: Mcp_Cap_Listen_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchar`)
};

/**
* | output |
* | --- |
* | "Listen" |
*
* @param {Mcp_Cap_Listen_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_listen_label = /** @type {((inputs?: Mcp_Cap_Listen_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Listen_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_listen_label(inputs)
	return en_mcp_cap_listen_label(inputs)
});